module.exports = __webpack_public_path__ + "img/sw4-b2.06805f79.jpg";